module.exports = __webpack_public_path__ + "static/media/user-vector.2ec6b279.svg";